export function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function every(array, callback) {
  return Array.prototype.every.call(array, callback);
}

export function areObjectsEqual(...args: Array<any>) {
  const objects = arguments;
  return every(objects, (obj, i) => {
    if (i === 0) {
      return true;
    }

    const prevObject = objects[i - 1];
    const currObject = objects[i];

    if (!prevObject || !currObject) {
      return false;
    }

    if (typeof prevObject !== 'object' || typeof currObject !== 'object') {
      return false;
    }

    const doesPrevContainCurr = every(Object.keys(prevObject), key => {
      const prevValue = prevObject[key];
      const currValue = currObject[key];
      if (typeof prevValue === 'object' && typeof currValue === 'object') {
        return areObjectsEqual(prevValue, currValue);
      }
      return prevValue === currValue;
    });

    const doesCurrContainPrev = every(Object.keys(currObject), key => {
      const prevValue = prevObject[key];
      const currValue = currObject[key];
      if (typeof prevValue === 'object' && typeof currValue === 'object') {
        return areObjectsEqual(prevValue, currValue);
      }
      return prevValue === currValue;
    });

    return doesPrevContainCurr && doesCurrContainPrev;
  });
}



// WEBPACK FOOTER //
// ./utils/objects.ts